<div [editableInStoryblok]="_editable" class="flex flex-col">
	@if (carousel) {
		<sb-carousel [config]="carousel.config" [items]="carousel.items" />
	}
	<div class="z-10 -mt-10 px-3 md:px-8">
		<div class="section-inner">
			@if (hotelSlug() !== undefined) {
				<sb-availability-widget
					[hotelGUID]="hotelGUID"
					[hotelSlug]="hotelSlug()"
					[openAvailabilityInNewTab]="openInNewTab()"
				/>
			} @else {
				<sb-availability-widget
					[hotelGUID]="hotelGUID"
					[openAvailabilityInNewTab]="openInNewTab()"
				/>
			}
		</div>
	</div>
</div>
